<div class="card">
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" class="m-3" (closed)="alertInfo.show = false">
      <div [innerHTML]="alertInfo.message"></div>
    </ngb-alert>
  }
  <div class="card-header d-flex p-2">
    <ul class="nav nav-pills">
      @for (lang of languages; track lang) {
        <li class="nav-item"> <a class="nav-link flag-button"
          [class.active]="activeTab === lang.code" (click)="activeTab = lang.code"><img [src]="lang.flag"
          [alt]="lang.label" class="flag-image" [class.active]="activeTab === lang.code">
          <p class="mt-2 mb-0">{{lang.code}}</p>
        </a>
      </li>
    }
  </ul>
</div>
<div class="card-body">
  <div class="tab-content" [formGroup]="form">
    @if (activeTab == 'eng') {
      <div class="tab-pane" [class.active]="activeTab == 'eng'">
        <textarea-field label="Article Details" placeholder="Write your note here..."
          [textareaFormControl]="getTranslationsEngInput()"
          [readonly]="readonlyTranslationsDetails"/>
      </div>
    }
    @if (activeTab == 'ita') {
      <div class="tab-pane" [class.active]="activeTab == 'ita'">
        <textarea-field label="Dettagli Articolo" placeholder="Write your note here..."
          [textareaFormControl]="getTranslationsItaInput()"
          [readonly]="readonlyTranslationsDetails"/>
      </div>
    }
    @if (activeTab == 'spa') {
      <div class="tab-pane" [class.active]="activeTab == 'spa'">
        <textarea-field label="Detalles del Artículo" placeholder="Write your note here..."
          [textareaFormControl]="getTranslationsSpaInput()"
          [readonly]="readonlyTranslationsDetails"/>
      </div>
    }
  </div>
</div>
</div>